import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=369f9672"
import script from "./ProfileData.vue?vue&type=script&lang=ts"
export * from "./ProfileData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('369f9672')) {
      api.createRecord('369f9672', component.options)
    } else {
      api.reload('369f9672', component.options)
    }
    module.hot.accept("./ProfileData.vue?vue&type=template&id=369f9672", function () {
      api.rerender('369f9672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/ProfileData.vue"
export default component.exports